/**
 * Local-timezone date helpers.
 *
 * Why this exists: `Date.prototype.toISOString()` always formats in UTC, which
 * silently drops a day for users east of UTC when it's early morning locally
 * (e.g. East Africa Time / UTC+3: between 00:00 and 03:00 local, toISOString
 * reads as yesterday). The same problem bites `changeDate`-style arithmetic —
 * after `d.setDate(d.getDate() + 1)` the `.toISOString()` readout can round
 * the date back down by one.
 *
 * These helpers read Date components via the browser's LOCAL timezone
 * (`getFullYear`, `getMonth`, `getDate`), which keeps generated YYYY-MM-DD
 * strings aligned with the user's wall clock and with how admins enter
 * `scheduled_date` on the backend (also a local date string, never UTC).
 *
 * Use in any place that previously called:
 *     new Date().toISOString().split('T')[0]
 *     someDate.toISOString().slice(0, 10)
 */

/** Convert a Date object into a YYYY-MM-DD string in local time. */
export function toLocalDateString(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Today's date (YYYY-MM-DD) in the user's local timezone. */
export function todayLocalDateString() {
  return toLocalDateString(new Date());
}
